import { keys } from 'lodash';
import { IRoute, IRoutePath } from 'types/common';

export const APP_ROUTES = {
	default: '/',
	home: '/home',
	gettingStarted: '/gettingStarted',
	notFound: '/oops',
	login: '/login',
	magicLinkVerify: '/magiclink/verify',
	oauthExchange: '/oauth/exchange',
	samlExchange: '/saml/exchange',
	users: '/users',
	audits: '/audits',
	accessKeys: '/accesskeys',
	authorization: '/authorization',
	roles: '/authorization/roles',
	permissions: '/authorization/permissions',
	flows: '/flows',
	flowsBuilder: '/flows/builder',
	flowsBuilderEdit: '/flows/builder/:flowId',
	flowStyleEditor: '/styles',
	help: '/help',
	tenants: '/tenants',
	tenantDetails: '/tenants/:tenantId',
	tenant: '/tenants/:tenantId/:settings',
	company: '/settings/company',
	companySettings: '/settings/company/settings',
	companyAdmins: '/settings/company/admins',
	companyManagementKeys: '/settings/company/managementkeys',
	projectSettings: '/settings/project',
	authMethods: '/settings/authentication',
	authMethodsOTP: '/settings/authentication/otp',
	authMethodsMagicLink: '/settings/authentication/magiclink',
	authMethodsEnchantedLink: '/settings/authentication/enchantedlink',
	authMethodsSocial: '/settings/authentication/social',
	authMethodsSSO: '/settings/authentication/sso',
	authMethodsWebAuthn: '/settings/authentication/webauthn',
	authMethodsTOTP: '/settings/authentication/totp',
	authMethodsPassword: '/settings/authentication/password',
	pageEditor: '/pageeditor'
};

export enum AuthMethodRoute {
	OTP = 'otp',
	MagicLink = 'magiclink',
	EnchantedLink = 'enchantedlink',
	Social = 'social',
	SSO = 'sso',
	WebAuthn = 'webauthn',
	TOTP = 'totp',
	Password = 'password'
}

export const APP_ROUTES_ATTRIBUTES: { [index: string]: IRoute } = {
	[APP_ROUTES.default]: {
		navigationAccess: false,
		mobileSupported: true
	},
	[APP_ROUTES.home]: {
		navigationAccess: true,
		labelId: 'pages.home.title',
		mobileSupported: true
	},
	[APP_ROUTES.gettingStarted]: {
		navigationAccess: true,
		labelId: 'pages.gettingStarted.title',
		mobileSupported: true
	},
	[APP_ROUTES.users]: {
		navigationAccess: true,
		labelId: 'pages.users.title',
		mobileSupported: true
	},
	[APP_ROUTES.audits]: {
		navigationAccess: true,
		labelId: 'pages.audits.title',
		mobileSupported: true
	},
	[APP_ROUTES.accessKeys]: {
		navigationAccess: true,
		labelId: 'pages.accessKeys.title',
		mobileSupported: true
	},
	[APP_ROUTES.authorization]: {
		navigationAccess: false,
		labelId: 'pages.authorization.title',
		mobileSupported: true
	},
	[APP_ROUTES.roles]: {
		navigationAccess: true,
		labelId: 'pages.roles.title',
		mobileSupported: true
	},
	[APP_ROUTES.permissions]: {
		navigationAccess: true,
		labelId: 'pages.permissions.title',
		mobileSupported: true
	},
	[APP_ROUTES.pageEditor]: {
		navigationAccess: false,
		labelId: 'pages.pageEditor.title',
		fullWidth: true
	},
	[APP_ROUTES.flowStyleEditor]: {
		navigationAccess: true,
		labelId: 'pages.flowStyleEditor.title',
		fullWidth: true
	},
	[APP_ROUTES.flows]: {
		navigationAccess: true,
		labelId: 'pages.flows.title'
	},
	[APP_ROUTES.flowsBuilder]: {
		navigationAccess: false,
		labelId: 'pages.flows.title',
		fullWidth: true
	},
	[APP_ROUTES.flowsBuilderEdit]: {
		navigationAccess: false,
		fullWidth: true
	},
	[APP_ROUTES.tenants]: {
		navigationAccess: true,
		labelId: 'pages.tenants.title',
		mobileSupported: true
	},
	[APP_ROUTES.authMethods]: {
		navigationAccess: true,
		labelId: 'pages.authenticationMethods.title',
		fullWidth: true
	},
	[APP_ROUTES.projectSettings]: {
		navigationAccess: true,
		labelId: 'pages.projectSettings.title',
		mobileSupported: true
	},
	[APP_ROUTES.company]: {
		navigationAccess: false,
		labelId: 'pages.company.title',
		mobileSupported: true
	},
	[APP_ROUTES.companySettings]: {
		navigationAccess: true,
		labelId: 'pages.company.title',
		mobileSupported: true
	},
	[APP_ROUTES.companyAdmins]: {
		navigationAccess: true,
		labelId: 'company.tabs.admins.title',
		mobileSupported: true
	},
	[APP_ROUTES.companyManagementKeys]: {
		navigationAccess: true,
		labelId: 'company.tabs.managementKeys.title',
		mobileSupported: true
	},
	[APP_ROUTES.magicLinkVerify]: {
		navigationAccess: false,
		disableDevRev: true,
		mobileSupported: true
	},
	[APP_ROUTES.oauthExchange]: {
		navigationAccess: false,
		disableDevRev: true,
		mobileSupported: true
	},
	[APP_ROUTES.samlExchange]: {
		navigationAccess: false,
		disableDevRev: true,
		mobileSupported: true
	},
	[APP_ROUTES.notFound]: {
		navigationAccess: false,
		disableDevRev: true,
		fullWidth: true,
		mobileSupported: true
	},
	[APP_ROUTES.login]: {
		navigationAccess: false,
		disableDevRev: true,
		mobileSupported: true
	},
	[APP_ROUTES.help]: {
		navigationAccess: false,
		fullWidth: true,
		mobileSupported: true
	},
	[APP_ROUTES.tenantDetails]: {
		navigationAccess: false,
		mobileSupported: true
	},
	[APP_ROUTES.tenant]: {
		navigationAccess: false,
		mobileSupported: true
	},
	[APP_ROUTES.authMethodsOTP]: {
		navigationAccess: false
	},
	[APP_ROUTES.authMethodsMagicLink]: {
		navigationAccess: false
	},
	[APP_ROUTES.authMethodsEnchantedLink]: {
		navigationAccess: false
	},
	[APP_ROUTES.authMethodsPassword]: {
		navigationAccess: false
	},
	[APP_ROUTES.authMethodsSocial]: {
		navigationAccess: false
	},
	[APP_ROUTES.authMethodsSSO]: {
		navigationAccess: false
	},
	[APP_ROUTES.authMethodsWebAuthn]: {
		navigationAccess: false
	},
	[APP_ROUTES.authMethodsTOTP]: {
		navigationAccess: false
	}
};

export const NAVIGATION_ACCESSIBLE_ROUTES = keys(APP_ROUTES_ATTRIBUTES)
	.filter((key) => APP_ROUTES_ATTRIBUTES[key].navigationAccess)
	.map((path) => {
		const route = APP_ROUTES_ATTRIBUTES[path];
		return {
			path,
			...route
		} as IRoutePath;
	});

export const DEV_REV_DISABLED_ROUTES = keys(APP_ROUTES_ATTRIBUTES).filter(
	(key) => APP_ROUTES_ATTRIBUTES[key].disableDevRev
);

export const FULL_WIDTH_ROUTES = keys(APP_ROUTES_ATTRIBUTES).filter(
	(key) => APP_ROUTES_ATTRIBUTES[key].fullWidth
);

export const MOBILE_SUPPORTED_ROUTES = keys(APP_ROUTES_ATTRIBUTES).filter(
	(key) => APP_ROUTES_ATTRIBUTES[key].mobileSupported
);
